import preloader from "./preloader";
import {displayFormError} from "./helper";

var forms = function () {
    // Feedback form

    $('.feedback-form').on('submit', function(e){
        e.preventDefault();

        let form = $(this);

        // in-flight guard: a double click must not send two identical emails
        if(form.data('submitting')){
            return;
        }

        form.data('submitting', true);

        let buttons = form.find('button[type="submit"]');

        buttons.prop('disabled', true);

        preloader(form, true);

        form.find('.danger-alert').addClass('d-none');
        form.find('.success-alert').addClass('d-none');

        $.ajax({
            url: form.attr('action'),
            dataType: 'json',
            type: 'post',
            data: form.serialize(),
            success: function( response ){
                // the server answers 2xx only when the message was really sent
                form.trigger('reset');

                preloader(form, false);

                form.find('.success-alert').removeClass('d-none');
            },
            error: function( responseError){
                // keep whatever the user typed, just show the error
                displayFormError(form, responseError)
            },
            complete: function(){
                form.data('submitting', false);

                buttons.prop('disabled', false);
            }
        });
    })
}

export default forms;



// WEBPACK FOOTER //
// ./resources/assets/js/functions/forms.js